export default __webpack_public_path__ + "static/media/Mark-5-HUD-00.e4c5e269.jpg";